import React, { useState, useEffect } from 'react';
import PurchasesTable from '../components/PurchasesTable';
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Snackbar, Alert, FormControl, InputLabel, Select } from '@mui/material';
import api from '../api/axios';

interface PurchasesPageProps {
  tenantId?: number;
}

const PurchasesPage: React.FC<PurchasesPageProps> = ({ tenantId }) => {
  const [redeemOpen, setRedeemOpen] = useState(false);
  const [platforms, setPlatforms] = useState<string[]>([]);
  const [platform, setPlatform] = useState('');
  const [amount, setAmount] = useState('');
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    // Fetch platforms for dropdown
    api.get('/api/v1/platforms/all').then(res => setPlatforms((res.data as any[]).map((p: any) => p.name))).catch(() => setPlatforms([]));
  }, []);

  const handleRedeem = async () => {
    try {
      await api.post('/api/v1/checkout/redeem', { platform_name: platform, amount: Number(amount) });
      setSnackbar({ open: true, message: 'Redeem request submitted!', severity: 'success' });
      setRedeemOpen(false);
      setPlatform('');
      setAmount('');
    } catch (e: any) {
      setSnackbar({ open: true, message: e?.response?.data?.detail || 'Failed to submit redeem request', severity: 'error' });
    }
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>Purchases (Top-Ups Only)</Typography>
      <Button variant="outlined" sx={{ mb: 2 }} onClick={() => setRedeemOpen(true)}>Redeem</Button>
      <Dialog open={redeemOpen} onClose={() => setRedeemOpen(false)}>
        <DialogTitle>Redeem</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="normal">
            <InputLabel>Platform</InputLabel>
            <Select value={platform} label="Platform" onChange={e => setPlatform(e.target.value)}>
              {platforms.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField label="Amount" type="number" fullWidth margin="normal" value={amount} onChange={e => setAmount(e.target.value)} inputProps={{ min: 100, max: 1000 }} helperText="Min 100, Max 1000 per day" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRedeemOpen(false)}>Cancel</Button>
          <Button onClick={handleRedeem} variant="contained" disabled={!platform || !amount || Number(amount) < 100 || Number(amount) > 1000}>Submit</Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
      <PurchasesTable tenantId={tenantId} transactionType="TOP_UP" />
    </Box>
  );
};

export default PurchasesPage; 